// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutCompanyBackground_wrapper__YAbea","firstColor":"AboutCompanyBackground_firstColor__UgqnB","secondColor":"AboutCompanyBackground_secondColor__0dPCj"};